<svg
  class="overflow-visible font-bold"
  width="152"
  height="62"
  viewBox="0 0 152 62"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g filter="url(#filter0_dd_593_2116)">
    <path
      d="M15 15C15 12.7909 16.7909 11 19 11H133C135.209 11 137 12.7909 137 15V32C137 34.2091 135.209 36 133 36H15V15Z"
      fill="#DC513F"
    />
    <text id="dynamicText" x="76" y="28" font-family="Sofia Pro" font-size="11" fill="white" text-anchor="middle">
      {{ bannerText() | bgoTruncate: 16 : false : '' }}
    </text>
    <path d="M15 36H21V43H19C16.7909 43 15 41.2091 15 39V36Z" fill="#DC513F" />
    <path d="M15 39.5C15 37.567 16.567 36 18.5 36H21V43H18.5C16.567 43 15 41.433 15 39.5Z" fill="#BD2D1A" />
  </g>
  <defs>
    <filter
      id="filter0_dd_593_2116"
      x="0"
      y="0"
      width="152"
      height="62"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_dropShadow_593_2116" />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="8" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0" />
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_593_2116" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="2" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
      <feBlend mode="normal" in2="effect1_dropShadow_593_2116" result="effect2_dropShadow_593_2116" />
      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_593_2116" result="shape" />
    </filter>
  </defs>
</svg>
